import React from 'react'

import * as Styled from './styles'

interface Props {
  onClick: () => void
  label: string
}

const CloseButton: React.FC<Props> = ({ onClick, label }) => {
  return (
    <Styled.CloseButton onClick={onClick}>
      <i className="fal fa-plus" aria-hidden="true" />
      <span className="screen-reader screen-reader-focusable">{label}</span>
    </Styled.CloseButton>
  )
}

export default CloseButton
